import { WeldProcedure } from '@bechtel/types';

export interface WeldProcedureProps {
  fieldName: string;
  items: WeldProcedure[];
  onSelectedItemChange?: (selectedWeldProcedureId: WeldProcedure['id']) => void;
}
